var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return this.groupQuestions.length > 0
    ? _c(
        "div",
        { staticClass: "explanation-preview" },
        [
          _vm._l(_vm.groupQuestions, function (question, index) {
            return [
              _c("h3", { staticClass: "explanation-title" }, [
                _vm._v(
                  "解説" +
                    _vm._s(_vm.groupQuestions.length > 1 ? index + 1 : "")
                ),
              ]),
              _vm._v(" "),
              _c("SkillPreviewComponent", { attrs: { question: question } }),
              _vm._v(" "),
              _c("div", {
                staticClass: "explanation-preview-content",
                domProps: { innerHTML: _vm._s(_vm.getContent(question)) },
              }),
            ]
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }